import type {
    KpisResumo,
    PontoCliente,
    PontoDia,
    PontoExtra,
    PontoMes,
    PontoProduto,
    PontoTipo,
} from "../../../services/resumoFornecedor"

export type { PontoDia, PontoMes, PontoTipo, PontoExtra, PontoProduto, PontoCliente }

export type ResumoFornecedorModel = {
    possuiDelivery: boolean
    kpis: KpisResumo
    pontosFaturamento: PontoDia[]
    pontosExpirado: PontoDia[]
    pontosMes: PontoMes[]
    pontosMesVendasTipo: PontoTipo[]
    pontosInfoExtras: PontoExtra[]
    pontosProdutoMaisVendido: PontoProduto[]
    melhoresClientes: PontoCliente[]
    totalExpirados: number
    dataInicio: string
    dataFim: string
}

function dataInicioDefault(): string {
    const d = new Date()
    d.setDate(d.getDate() - 6)
    return d.toISOString().slice(0, 10)
}

function dataFimDefault(): string {
    return new Date().toISOString().slice(0, 10)
}

const kpisVazio: KpisResumo = {
    totalPedidos: 0,
    totalVendido: 0,
    totalClientes: 0,
    ticketMedio: 0,
    frequenciaMedia: 0,
    clientesAtivos: 0,
    nps: 0,
    qtdPix: 0,
    valorPix: 0,
}

export const ResumoFornecedorInicial: ResumoFornecedorModel = {
    possuiDelivery: false,
    kpis: kpisVazio,
    pontosFaturamento: [],
    pontosExpirado: [],
    pontosMes: [],
    pontosMesVendasTipo: [],
    pontosInfoExtras: [],
    pontosProdutoMaisVendido: [],
    melhoresClientes: [],
    totalExpirados: 0,
    dataInicio: dataInicioDefault(),
    dataFim: dataFimDefault(),
}
